export default "__VITE_ASSET__CqhCLKnv__"